import { useState, useEffect, useCallback } from 'react';

// Хук для управления производительностью изображений
export const useImagePerformance = () => {
  const [isSlowConnection, setIsSlowConnection] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    // Определяем медленное соединение
    if ('connection' in navigator) {
      const connection = navigator.connection;
      const slowConnection = connection.effectiveType === 'slow-2g' || 
                           connection.effectiveType === '2g' ||
                           connection.saveData === true;
      setIsSlowConnection(slowConnection);

      // Слушаем изменения соединения
      const handleConnectionChange = () => {
        const slowConnection = connection.effectiveType === 'slow-2g' || 
                             connection.effectiveType === '2g' ||
                             connection.saveData === true;
        setIsSlowConnection(slowConnection);
      };

      connection.addEventListener('change', handleConnectionChange);
      return () => connection.removeEventListener('change', handleConnectionChange);
    }

    // Проверяем предпочтения пользователя
    if (window.matchMedia) {
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      setPrefersReducedMotion(reducedMotionQuery.matches);

      const handleMotionChange = (e) => {
        setPrefersReducedMotion(e.matches);
      };

      reducedMotionQuery.addEventListener('change', handleMotionChange);
      return () => reducedMotionQuery.removeEventListener('change', handleMotionChange);
    }
  }, []);

  // Функция для получения настроек изображения
  const getImageSettings = useCallback(() => {
    return {
      quality: isSlowConnection ? 'low' : 'auto',
      format: isSlowConnection ? 'jpeg' : 'auto',
      preloadMargin: isSlowConnection ? '50px' : '100px'
    };
  }, [isSlowConnection]);

  return {
    isSlowConnection,
    prefersReducedMotion,
    getImageSettings
  };
};

// Хук для предзагрузки изображений
export const useImagePreloader = () => {
  const preloadImages = useCallback((imageUrls) => {
    if (!imageUrls || imageUrls.length === 0) return;

    imageUrls.forEach(url => {
      if (url) {
        const img = new Image();
        img.src = url;
      }
    });
  }, []);

  return { preloadImages };
};